import styled from 'styled-components';

export const PostPreviewListWrapper = styled.div`
  max-width: 1180px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
`;

export const PostPreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #FFF;
  padding: 20px;
  box-shadow: inset 0 0 0 1px #dae4ed, 0 5px 15px -5px rgba(0,0,0,.1);
  border-radius: 9px;
  margin-top: 22px;
  @media (max-width: 767px) {
    flex-basis: 100%;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    flex-basis: calc(50% - 25px);
    margin-right: 11px;
    margin-left: 11px;
  }
  @media (min-width: 1024px) {
    flex-basis: calc(33% - 25px);
    margin-left: 11px;
    margin-right: 11px;
  }
`;

export const PostPreviewTitle = styled.h3`
  font-size: 26px;
  font-weight: 500;
  line-height: 35px;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const PostPreviewTeaser = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 16px;
`;

export const PostPreviewMetaWrapper = styled.div`
  margin-top: auto;
`;


// WEBPACK FOOTER //
// ./src/components/Preview/styled/index.js